import React from 'react';

import {TAG_SCHEMA_CONTAINABLE_TYPE} from 'constants/RegistryConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import BioentitySearchInput from 'inventory/BioentitySearchInput';
import CreateAndRegisterBioentityInputs from 'registry/create-bioentity/CreateAndRegisterBioentityInputs';
import {CreateAndRegisterBioentityArgs} from 'registry/create-bioentity/CreateBioentityUtil';
import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import {InputChangeEvent} from 'util/Types';

import * as InputSampleConstants from './InputSampleConstants';

function isExistingBioentity(inputType: InputSampleConstants.TYPE): boolean {
  return InputSampleConstants.HAS_EXISTING_BIOENTITY_TYPES.includes(inputType);
}
function isNewBioentity(inputType: InputSampleConstants.TYPE): boolean {
  return InputSampleConstants.HAS_NEW_BIOENTITY_TYPES.includes(inputType);
}

interface InputTypeOptionsProps {
  inputType: InputSampleConstants.TYPE;
  onChange: (e: InputChangeEvent) => void;
}

function InputTypeOptions({inputType, onChange}: InputTypeOptionsProps): JSX.Element {
  return (
    <span>
      <Label className="radio-inline radio-inline--labelAligned u-spacing-right">
        <input
          type="radio"
          name="findOrCreateBioentity-inputType"
          value={InputSampleConstants.HAS_EXISTING_BIOENTITY_TYPES[0]}
          checked={isExistingBioentity(inputType)}
          onChange={onChange}
        />
        Search for entity
      </Label>
      <Label className="radio-inline radio-inline--labelAligned">
        <input
          type="radio"
          name="findOrCreateBioentity-inputType"
          value={InputSampleConstants.HAS_NEW_BIOENTITY_TYPES[0]}
          checked={isNewBioentity(inputType)}
          onChange={onChange}
        />
        Register new entity
      </Label>
    </span>
  );
}

interface FindOrCreateBioentityProps {
  createAndRegisterBioentityArgs: CreateAndRegisterBioentityArgs;
  inputBioentity: BioentitySummary | null;
  inputType: InputSampleConstants.TYPE;
  onChangeCreateAndRegisterBioentityArgs: (
    changeCreateAndRegisterBioentityArgs: Partial<CreateAndRegisterBioentityArgs>
  ) => void;
  onChangeInputBioentity: (bioentity: BioentitySummary | Item | null) => void;
  onChangeInputType: (e: InputChangeEvent) => void;
}

export default function FindOrCreateBioentity({
  createAndRegisterBioentityArgs,
  inputBioentity,
  inputType,
  onChangeCreateAndRegisterBioentityArgs,
  onChangeInputBioentity,
  onChangeInputType,
}: FindOrCreateBioentityProps): JSX.Element {
  return (
    <div>
      <FormGroup>
        <InputTypeOptions inputType={inputType} onChange={onChangeInputType} />
      </FormGroup>

      <FormGroup>
        {isExistingBioentity(inputType) ? (
          <BioentitySearchInput
            onChange={(selectedItems) => {
              onChangeInputBioentity(selectedItems.length ? selectedItems[0] : null);
            }}
            selectedItems={inputBioentity ? [inputBioentity] : []}
            containableItemsOnly={true}
          />
        ) : (
          <div className="well">
            <CreateAndRegisterBioentityInputs
              createAndRegisterBioentityArgs={createAndRegisterBioentityArgs}
              onChange={onChangeCreateAndRegisterBioentityArgs}
              isTagSchemaDisabledFn={(ts) => ts.containableType === TAG_SCHEMA_CONTAINABLE_TYPE.NONE}
              tagSchemaDisabledMessage="not containable"
              labelStyle={LabelStyle.SUBLABEL}
              showStudiesField={true}
              showSchemaSelector={true}
            />
          </div>
        )}
      </FormGroup>
    </div>
  );
}
